// extracted by mini-css-extract-plugin
export default {"label":"ServerSettings_label__5oEbi","section":"ServerSettings_section__KPpcE","input":"ServerSettings_input__FCv4F"};